import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Campaign } from "../../../models/campaign";
import agent from "../../../api/agent";
import CenteredCard from "../../../layout/CenteredCard";
import { env } from "../../../utils/env";
import TouchWin from "../../../../components/TouchWin/TouchWin";

export default function CustomGameBoard() {
  const { id } = useParams<{ id: string }>();
  const [campaign, setCampaign] = useState<Campaign | null>(null);

  let background = "";
  let backgroundSize = "";
  const screenColor = campaign?.screenStyle.screenColor || "#E60805";
  if (campaign?.screenStyle.screenBg) {
    const screenBgUrl = campaign.screenStyle.screenBg.startsWith("http")
      ? campaign.screenStyle.screenBg
      : env + campaign.screenStyle.screenBg;
    background = `url(${screenBgUrl}) center center no-repeat, ${screenColor}`;
    backgroundSize = "cover, auto";
  } else {
    backgroundSize = "auto";
    background = screenColor;
  }

  const fetchCampaign = async () => {
    if (id) {
      try {
        const fetchedCampaign = await agent.Campaigns.details(id);
        setCampaign(fetchedCampaign);
      } catch (error) {
        console.error("Failed to fetch campaign:", error);
      }
    } else {
      console.error("No campaign id provided");
    }
  };

  useEffect(() => {
    fetchCampaign();
  }, [id]);

  if (!campaign) {
    return <CenteredCard>Yükleniyor...</CenteredCard>;
  }

  return (
    <>
      <style>
        {campaign.screenStyle.titleFromTop &&
          `
          .game-screen h3 {
            margin-top: ${campaign.screenStyle.titleFromTop}px;
            max-width: ${campaign.screenStyle.titleWidth}%;
          }
        `}
        {campaign.screenStyle.titleFontSize &&
          `
          .game-screen h3 {
            font-size: ${campaign.screenStyle.titleFontSize}px;
          }
        `}
        {campaign.screenStyle.logoHeight &&
          `
          .game-screen .screen-logo {
            max-height: ${campaign.screenStyle.logoHeight}px;
          }
        `}
        {campaign.screenStyle.logoFromTop &&
          `
          .game-screen .screen-logo {
            margin-top: ${campaign.screenStyle.logoFromTop}px;
          }
        `}
        {campaign.customCSS}
      </style>
      <main
        className="game-screen custom"
        style={{
          color: campaign.screenStyle.textColor || "fff",
          background: background,
          backgroundSize: backgroundSize,
        }}
      >
        {campaign.gameType === 4 && campaign.touchWin ? (
          <TouchWin
            isActive={campaign.isActive}
            collectUserData={campaign.collectUserData}
            touchWin={campaign.touchWin}
            screenStyle={campaign.screenStyle}
            formState={campaign.formState}
            campaignId={campaign.id}
          />
        ) : (
          <CenteredCard>Bu kampanya için oyun bulunamadı.</CenteredCard>
        )}
      </main>
    </>
  );
}
